import chmln from '@chamaeleonidae/chmln';

export function initChameleon() {
  chmln.init('SX1RvxZ2UZ2pMElYfHGiVi4l9LNFZu28Jd5CyUZGYG7gNk-1QhbnC-EvFpzPwaTh8i7xKj', { fastUrl: 'https://fast.chameleon.io/' });
}

export function identifyUser(userId, preferredName) {
  chmln.identify(userId, { name: preferredName });
}